import styles from '../styles/LoadingLogo.module.css';

const LoadingScreen = () => {
  return (
    <div className="fixed inset-0 bg-white bg-opacity-80 backdrop-blur-sm flex items-center justify-center z-50">
      <div className={styles.logoContainer}>
        <img 
          src="/logoicon.png" 
          alt="Loading..." 
          className={styles.animatedLogo}
        />
      </div>
    </div>
  );
};

export default LoadingScreen; 